import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { HemerotecaType, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { HemerotecaModel, StrapiResponseModel } from '@/interfaces/model';
import { hemerotecaListMapper } from '@/mappers';

export const getHemerotecaResults = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<HemerotecaType>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/hemerotecas',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<HemerotecaModel>;
					return hemerotecaListMapper(json);
				},
			],
		}),
		controller,
	};
};
